<template>
  <div id="Report-gen">
    <IForm ref="formInline" :label-width="150" :model="edit" :submit="false"  @on-submit="toSubmit">
      <div slot="extend">
       <FormItem label="批量关联报告">
          <el-select v-model="edit.batchReportId" :multiple="true" :filterable="true" clearable placeholder="请选择" @change="relevance" style="width: 95%;">
            <el-option v-for="item in reportList" :key="item.id" :value="item.id" :label="item.name" style="width: 100%;"/>
          </el-select>
        </FormItem>

        <FormItem :label="classItem.name" v-for="classItem in classList">
          <el-select v-model="edit[classItem.classId]" :multiple="true" :filterable="true" clearable placeholder="请选择" @change="(val) => classChoose(val, classItem)" style="width: 95%;">
            <el-option v-for="item in reportList" :key="item.id" :value="item.id" :label="item.name" style="width: 100%;"/>
          </el-select>
        </FormItem>
      </div>
    </IForm>

  </div>
</template>
<script>
import {_linkReport, _generateReport} from "@/services/task/task";
import {_reportList} from "@/services/studentManage/studentManage";
export default {
  name: "ReportGen",
  data() {
    return {
      taskId: "",
      classList:[],
      reportList:[],
      edit: {
        batchReportId: []
      },
      init: "",
    };
  },
  mounted() {
    this.reportName();
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    className(taskId){
      _linkReport({taskId:taskId}).then(res=>{
        if (res.errcode === 1 && res.data) {
          this.classList = res.data;
          if(this.classList&&this.classList.length>0){
            this.classList.forEach((item,_index)=>{
              this.edit[item.classId] = item.reportId;
            })
          }
        }
      });
    },
    reportName(){
      _reportList().then(res=>{
        if (res.errcode === 1 && res.data) {
          this.reportList = res.data;
        }
      });
    },
    relevance(selectedValue){
      this.classList.forEach((item,_index)=>{
          this.edit[item.classId] = selectedValue;
      })
    },
    classChoose(selectedValue, item){
      this.edit[item.classId] = selectedValue
      this.$forceUpdate();
    },
    handleModal(taskId) {
      this.taskId = taskId;
      this.edit.batchReportId = [];
      this.className(taskId);
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      const reportInfo = [];
      this.classList.forEach((item,_index)=>{
        if(this.edit[item.classId]&&this.edit[item.classId].length>0){
          reportInfo.push({classId: item.classId, name: item.name, reportIds: this.edit[item.classId]});
        }else{
          reportInfo.push({classId: item.classId, name: item.name, reportIds: []});
        }
      })

      _generateReport({taskId: this.taskId,reportInfo : reportInfo}).then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
</style>
